import React, { useEffect } from 'react';

const typeClasses = {
  success: 'border-green-200 bg-green-50 text-green-800',
  error: 'border-red-200 bg-red-50 text-red-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-900',
  info: 'border-[#E4D4EA] bg-[#FBF7FD] text-[#4B2A56]',
};

const typeIcons = {
  success: '✅',
  error: '⚠️',
  warning: '⚠️',
  info: 'ℹ️',
};

const Notification = ({ message, type, onClose }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        onClose();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  const resolvedType = typeClasses[type] ? type : 'info';

  return (
    <div className="pointer-events-none fixed inset-x-0 top-4 z-[1100] mx-auto flex w-full max-w-xl justify-center px-3">
      <div
        role={resolvedType === 'error' ? 'alert' : 'status'}
        aria-live={resolvedType === 'error' ? 'assertive' : 'polite'}
        className={`pointer-events-auto flex w-full items-start gap-2 rounded-xl border px-4 py-3 text-sm shadow-lg ${typeClasses[resolvedType]}`}
      >
        <span aria-hidden="true" className="mt-[1px]">{typeIcons[resolvedType]}</span>
        <p className="flex-1 leading-5">{message}</p>
        <button
          type="button"
          onClick={onClose}
          aria-label="Dismiss notification"
          className="rounded px-2 py-1 text-xs font-semibold hover:bg-black/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#6D3B7E]"
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default Notification;
